import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import { useTranslation } from '../../../language';

export default function StooltestsWelcome() {

  const { t } = useTranslation();

  return (

    <PageProtectedLayout
      headline={t('page_hl_stooltests')}
      specify={t('page_sp_stooltests')}
    >

      {/* Main Page Content */}

    </PageProtectedLayout>

  );
}
